var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1061",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1061",
    transform: "translate(-1624.5 -914.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_292",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 292",
    x2: 15,
    transform: "translate(1625.5 923)",
    fill: "none",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_293",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 293",
    x2: 15,
    transform: "translate(1633 915.5) rotate(90)",
    fill: "none",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ca96fd4adc1688c23d9c33c3d60ba92a.svg";
export { ForwardRef as ReactComponent };